import { render, staticRenderFns } from "./LocalIndex.vue?vue&type=template&id=53a8289a&scoped=true&"
import script from "./LocalIndex.vue?vue&type=script&lang=js&"
export * from "./LocalIndex.vue?vue&type=script&lang=js&"
import style0 from "./LocalIndex.vue?vue&type=style&index=0&id=53a8289a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a8289a",
  null
  
)

export default component.exports